import { createContext } from 'react'

type Props = {
  selectedId: string | undefined
  setSelectedId: ((id: string) => void) | (() => void)
}

export const AccordionContext = createContext<Props>({
  selectedId: '',
  setSelectedId() {
    console.error('You forgot to put the Accordion provider')
  },
})
